import { observer } from 'mobx-react';
import { FC } from 'react';
import BranchZonesTableRow from '../../components/BranchZonesListRow/BranchZonesTableRow';
import branchEditStore from '../../store/branchEditStore';
import { DELIVERY_CONDITION } from '../../types/branchEdit';
import { BRANCH_DELIVERY_CONDITION, IReduced } from 'src/types/branches';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

const BranchZonesTable: FC = observer((): JSX.Element => {
  const onChangeValueByLocation = (branchZoneId: number, value: string, conditionType: DELIVERY_CONDITION) => {
    switch (conditionType) {
      case DELIVERY_CONDITION.DELIVERY_FEE:
        branchEditStore.changeBranchZoneDeliveryCondition(branchZoneId, { delivery_fee: value });
        break;
      case DELIVERY_CONDITION.MIN_ORDER:
        branchEditStore.changeBranchZoneDeliveryCondition(branchZoneId, { min_order: value });
        break;
      case DELIVERY_CONDITION.REDUCED_DELIVERY_FEE:
        branchEditStore.changeBranchZoneDeliveryCondition(branchZoneId, { delivery_fee: value }, true);
        break;
      case DELIVERY_CONDITION.ORDER_MORE_THAN:
        branchEditStore.changeBranchZoneDeliveryCondition(branchZoneId, { order_more_than: value }, true);
        break;
    }
  };
  const getReducedDeliveryFee = (area: IReduced[]): string => {
    if (!area.length) return String(0);
    return String(area[0].delivery_fee);
  };
  const getReducedOrderMoreThan = (area: IReduced[]): string => {
    if (!area.length) return String(0);
    return String(area[0].order_more_than);
  };
  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex w-100 mb-4">
        <ColumnTitle
          title="branch_delivery_zones_column_label"
          className="branch-zones-table__name-clmn"
          tooltipMessage="delivery_zones_mgmt_available_from_dm_section"
        />
        {branchEditStore.editableBranch.min_order_type === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <ColumnTitle title="branch_min_order_header" className="branch-zones-table__attr-clmn" />
        )}
        {branchEditStore.editableBranch.delivery_fee_type === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <ColumnTitle title="branch_delivery_fee_header" className="branch-zones-table__attr-clmn" />
        )}
        {branchEditStore.editableBranch.reduced_delivery_fee_type === BRANCH_DELIVERY_CONDITION.BY_LOCATION && (
          <>
            <ColumnTitle title="reduced_delivery_fee" className="branch-zones-table__attr-clmn" />
            <ColumnTitle title="order_more_than" className="branch-zones-table__attr-clmn" />
          </>
        )}
      </div>

      <ScrollableBlock showScrollbar scrollbarSize="small" className="d-flex flex-1 w-100" scrollClassName="overflow-x-hidden">
        {branchEditStore.editableBranch.areas?.map((branchArea) => (
          <BranchZonesTableRow
            id={branchArea.id}
            name={branchArea.name}
            minimumOrderValue={String(branchArea.min_order)}
            minimumOrderType={branchEditStore.editableBranch.min_order_type}
            deliveryFeeValue={String(branchArea.delivery_fee)}
            deliveryFeeType={branchEditStore.editableBranch.delivery_fee_type}
            reduceDeliveryFeeType={branchEditStore.editableBranch.reduced_delivery_fee_type}
            reduceDeliveryFeeValue={getReducedDeliveryFee(branchArea.reduced)}
            orderMoreThan={getReducedOrderMoreThan(branchArea.reduced)}
            onChangeValueByLocation={onChangeValueByLocation}
          />
        ))}
      </ScrollableBlock>
    </div>
  );
});

export default BranchZonesTable;
